import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { addOutline } from 'ionicons/icons';
import { useState } from 'react';
import ArticleLocationStockTable from './articleLocationStockTable';
import AddArticleLocationStockForm from './addArticleLocationStockForm';
import ModalPopup from '@ui/components/VnModal';
import { handleRolePermission } from '@infrastructure/helpers';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
const ArticleLocationStockTab = ({ formData, errors, onFieldChange, isStockTabBold }) => {
    const [isOpen, SetIsOpen] = useState(false);
    function oncloseClicked() {
        SetIsOpen(false);
    }
    const handleButtonClick = () => {
        SetIsOpen(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'Vn-supplier-attachments-button', children: _jsx("div", { children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: addOutline, onClick: handleButtonClick, isDisabled: !handleRolePermission(Permission.ARTIKELEN, PermissionType.Create), children: "Toevoegen Voorraad" }) }) }), _jsx("div", { className: 'mt-3', children: _jsx(_Fragment, { children: _jsx(ArticleLocationStockTable, { formData: formData, isStockTabBold: isStockTabBold }) }) }), _jsx(ModalPopup, { title: 'Nieuwe Voorraad', content: _jsx(AddArticleLocationStockForm, { onClose: oncloseClicked, formData: formData, updateCase: false, isStockTabBold: isStockTabBold }), onOpen: isOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' })] }));
};
export default ArticleLocationStockTab;
